import PageContainer from '@zenbusiness/zui/PageContainer';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'ZuiPageContainer',
  slot: 'Root',
  tag: PageContainer,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0),

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(0),
    },

    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(0),
    },
  }),
});
